import React, { useEffect } from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';

import { useLocation } from '@utils/hooks';

import { userActions, useStore } from '@modules';
import { IbanStatusesEnum, VerificationStatusesEnum } from '@modules/user/types';

import NewModal from '@components/NewModal';
import SetCountry from '@containers/SetCountry';
import ZHModal from '@containers/ZHModal';
// import KYCIntro from '@pages/VerifyIdentity/KYCIntro';

import style from './ContainerModals.scss';

const cn = bemCssModules(style, 'ContainerModals');
const { user_has_intention } = IbanStatusesEnum;
const { incomplete, failed } = VerificationStatusesEnum;

const ContainerModals: CustomFC = ({ className }) => {
  const [{ global, user }, dispatch] = useStore();
  const { zhModalType } = global;
  const { data, isSkippedKYC, isCountryModal } = user;

  const { pathname } = useLocation();

  const reviewErrors = data?.checks.review_status?.errors;
  const documentStatus = data?.checks.document;
  const checkEnabled = data?.checks.document_details.check_enabled;
  const isIbanStatus = data?.iban_status;
  const isIbanUserHasIntention = isIbanStatus === user_has_intention;

  const documentIncomplete = documentStatus === incomplete;
  const documentFailed = documentStatus === failed;
  const documentDuplicate = reviewErrors?.includes('DUPLICATE');

  const isCheckedDocuments =
    (documentIncomplete || (documentFailed && checkEnabled && !isIbanUserHasIntention)) &&
    !documentDuplicate;
  const isKYC = !isSkippedKYC && isCheckedDocuments;

  useEffect(() => {
    if (isKYC) dispatch(userActions.skipKYC());
  }, [pathname]);

  return (
    <>
      {/* <NewModal
        className={cn({ kyc: true }, [className])}
        hideCloseButton
        hideMobileCloseButton
        isOpen={isKYC}
        disableScroll
      >
        <KYCIntro />
      </NewModal> */}
      <NewModal
        className={cn({ zeroHash: true }, [className])}
        hideCloseButton
        hideMobileCloseButton
        isOpen={!!zhModalType}
      >
        <ZHModal />
      </NewModal>
      <NewModal
        className={cn({ country: true }, [className])}
        hideCloseButton
        hideMobileCloseButton
        isOpen={isCountryModal}
      >
        <SetCountry />
      </NewModal>
    </>
  );
};

export default ContainerModals;
